module.exports = __webpack_public_path__ + "img/nada.70d04272.jpg";